// Import React's useEffect hook for side effects
import { useEffect } from 'react';
// Import React Router's navigation hook
import { useNavigate } from 'react-router-dom';

// Function to dispatch a custom navigation event
export function handleAutoNavigate() {
  // Create a custom event with navigation data
  const event = new CustomEvent('handleAutoNavigate', { detail: { index: 1 } });
  // Dispatch the event to the document
  document.dispatchEvent(event);
}
// Custom hook for handling auto-navigation
export const useBaseHook = () => {
  // Get the navigate function from React Router
  const navigate = useNavigate();

  // Set up effect to run once on component mount
  useEffect(() => {
    // Event handler function for auto-navigation
    const handleAutoNavigate = (event: Event) => {
      // Cast the event to CustomEvent to access detail property
      const customEvent = event as CustomEvent;
      // Check if event has detail and index equals 1
      if (customEvent.detail && customEvent.detail.index === 1) {
        // Navigate back one page in history
        navigate(-1);
      }
    };

    // Add event listener for the custom navigation event
    document.addEventListener('handleAutoNavigate', handleAutoNavigate);
    // Cleanup function to remove event listener
    return () => {
      // Remove event listener when component unmounts
      document.removeEventListener('handleAutoNavigate', handleAutoNavigate);
    };
  }, []); // Empty dependency array means this runs once on mount
};
